<p-table #dt1 [value]="value" [rowHover]="true" styleClass="p-datatable-gridlines" responsiveLayout="scroll"
  editMode="row" [tableStyle]="{'min-height': '10rem'}" dataKey="Id">
  <ng-template pTemplate="caption">
    <div class="flex sm:flex-row">
      <button pButton label="Add" class="p-button-outlined mr-2" icon="pi pi-plus" (click)="addItem()"></button>
      @if(save.observed){
      <button pButton label="Save" icon="pi pi-save mr-2" (click)="save.emit(value)"></button>
      }
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th>Option</th>
      <th>Is Default</th>
      <th>Half & Half</th>
      <th>Prices</th>
      <th>Visibility</th>
      <th></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-choice let-editing="editing" let-ri="rowIndex" let-expanded="expanded">
    <tr [pEditableRow]="choice" [ngClass]="{'valign-top': editing}">
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <p-dropdown [options]="filteredOptions" [(ngModel)]="choice.MenuOptionId" optionLabel="Name"
              class="fixed-size" optionValue="Id"></p-dropdown>
          </ng-template>
          <ng-template pTemplate="output">
            <p-dropdown [options]="filteredOptions" [(ngModel)]="choice.MenuOptionId" optionLabel="Name"
              class="fixed-size" optionValue="Id" [disabled]="true"></p-dropdown>
          </ng-template>
        </p-cellEditor>
      </td>
      <td [ngClass]="{'align-center': editing}">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <p-checkbox binary="true" name="is-default" [(ngModel)]="choice.IsDefault"></p-checkbox>
          </ng-template>
          <ng-template pTemplate="output">{{choice.IsDefault}}</ng-template>
        </p-cellEditor>
      </td>
      <td [ngClass]="{'align-center': editing}">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <p-checkbox binary="true" name="disable-half-and-half" label="Not available"
              [(ngModel)]="choice.DisabledForHalfAndHalf"></p-checkbox>
          </ng-template>
          <ng-template pTemplate="output">{{choice.DisabledForHalfAndHalf ? 'Not available' : 'Available'}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <brt-menu-item-option-choice-price [(ngModel)]="choice.Prices"></brt-menu-item-option-choice-price>
            <div>
              <h6>Extra added price for order source</h6>
              <div class="p-formgrid grid p-fluid align-items-end tw-max-w-lg"
                *ngFor="let item of choice.SourcePrice; let index = index">
                <div class="field col-12 md:col-5">
                  <label htmlFor="type">Order Source</label>
                  <p-dropdown [options]="orderSources" [(ngModel)]="item.Source"></p-dropdown>
                </div>
                <div class="field col-12 md:col-5">
                  <label htmlFor="price">Extra Price</label>
                  <input pInputText type="number" [(ngModel)]="item.Price" />
                </div>
                <div class="field col-12 md:col-2">
                  <p-button icon="pi pi-trash" severity="danger" [text]="true"
                    (click)="choice.SourcePrice.splice(index, 1)"></p-button>
                </div>
              </div>
              <div class="tw-flex tw-justify-end">
                <p-button label="Add new source price" icon="pi pi-plus" severity="success"
                  (click)="choice.SourcePrice.push({})" size="small" [outlined]="true"></p-button>
              </div>

            </div>

          </ng-template>
          <ng-template pTemplate="output">
            @if(choice.Prices?.length){
            <p-tooltip target=".price-info-{{ri}}" [tooltipEvent]="'hover'" [tooltipPosition]="'top'"></p-tooltip>
            <i class="pi pi-info-circle price-info-{{ri}}" [title]="choice.Prices|json" style="cursor: pointer;"></i>
            {{choice.Prices?.length}} Price(s)
            }
          </ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <brt-menu-item-option-visibility [(ngModel)]="choice.Visibility"></brt-menu-item-option-visibility>
          </ng-template>
          <ng-template pTemplate="output">
            @if(choice.Visibility?.ChoiceOptionIds?.length){
            <p-tooltip target=".visibility-info-{{ri}}" [tooltipEvent]="'hover'" [tooltipPosition]="'top'"></p-tooltip>
            <i class="pi pi-info-circle visibility-info-{{ri}}" [title]="choice.Visibility.ChoiceOptionIds.join(', ')"
              style="cursor: pointer;"></i>
            {{choice.Visibility?.ChoiceOptionIds?.length}} Option(s)
            {{choice.Visibility.IsVisible?'Visible':'InVisible'}}
            }
          </ng-template>
        </p-cellEditor>
      </td>
      <td>
        <div class="flex align-items-center justify-content-center gap-2">
          <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
            class="p-button-rounded p-button-text btn-min"></button>
          <button *ngIf="!editing" pButton pRipple type="button" icon="pi pi-trash"
            class="p-button-rounded p-button-text p-button-danger btn-min" (click)="removeItem(ri)"></button>
          <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
            class="p-button-rounded p-button-text p-button-success mr-2 btn-min"></button>
          <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
            class="p-button-rounded p-button-text p-button-danger btn-min"></button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>